import { motion } from "framer-motion";

export const PageHero = ({ overline, title, subtitle, testid }) => (
  <section className="relative overflow-hidden border-b border-border bg-secondary/40 pt-[72px] grain" data-testid={testid}>
    <div className="dot-grid absolute inset-0 opacity-60" />
    <div className="container-x relative py-24 md:py-28">
      <motion.p
        initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="overline text-accent"
      >
        {overline}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.05 }}
        className="mt-5 max-w-4xl text-balance text-4xl font-semibold tracking-tighter sm:text-5xl lg:text-6xl"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-6 max-w-2xl text-lg font-light leading-relaxed text-muted-foreground"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
